const Screen = () => {
  return (
    <div>
      <h1>Home</h1>
    </div>
  );
};

export default Screen;
